import { constructQueryStringWithRepeatedKeys } from '@/utils/queryBuilderUtils';

interface GetUserRolesUrlProps {
  search?: string | null;
  page?: string | number;
}

export const getUserRolesUrl = ({ search, page }: GetUserRolesUrlProps) => {
  const queryParams: Record<string, string[]> = {};

  if (search) queryParams.query = [search];
  if (page) queryParams.page = [String(page)];

  return `/api/roles?${constructQueryStringWithRepeatedKeys(queryParams)}`;
};